import * as React from 'react';
import { Delopgave } from '../../models/Delopgave';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Col, Row } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import DraftHelper from '../../infrastructure/DraftHelper';
import { Section } from '../../uiComponents/layout/Section';
import RichTextEditor from '../../uiComponents/input/RichTextEditor';
import KonkurrenceDelopgaveSpoergsmaal from './KonkurrenceDelopgaveSpoergsmaal';
import { LinkSecondaryButton } from '../../uiComponents/input/Buttons';
import { maaBedoemme } from '../../infrastructure/Security';
import { KonkurrencestatusEnum } from '../../models/enums/KonkurrencestatusEnum';

export interface KonkurrenceOpgaveDelopgaveProps {
    delopgave: Delopgave;
    index: number;
    konkurrenceId: string;
    opgaveId: string;
    konkurrenceDag?: Date | undefined;
    konkurrenceStatus?: KonkurrencestatusEnum;
    readonly?: boolean;
}

class KonkurrenceOpgaveDelopgave extends React.Component<KonkurrenceOpgaveDelopgaveProps, any> {
    constructor(props: KonkurrenceOpgaveDelopgaveProps) {
        super(props);
        this.getTitle = this.getTitle.bind(this);
        this.getEditorState = this.getEditorState.bind(this);
    }

    getTitle() {
        return this.props.delopgave.titel;
    }

    getEditorState() {
        if (this.props.delopgave.indhold !== undefined) {
            return DraftHelper.getContentAsEditorState(this.props.delopgave.indhold);
        }

        return DraftHelper.getEmptyEditorState();
    }

    getDelopgaveSectionWithSpoergsmaal() {
        if (this.props.delopgave.skalStartesManuelt && (this.props.konkurrenceStatus !== undefined && this.props.konkurrenceStatus !== KonkurrencestatusEnum.Afviklet)) {
            return (
                <Section>
                    <Row>
                        <Col md={12}>
                            <p>I får opgaven på konkurrencedagen.</p>
                        </Col>
                    </Row>
                </Section>
            );
        } else {
            return (
                <div>
                    <Section>
                        <Row>
                            <Col md={8} mdOffset={3}>
                                <RichTextEditor readOnly={true} editorState={this.getEditorState()} />
                            </Col>
                        </Row>
                    </Section>
                    {this.getDelopgaveSpoergsmaal()}
                </div>
            );
        }
    }

    getDelopgaveSpoergsmaal() {
        let i = 0;
        let numOfQuestions = this.props.delopgave.multipleChoiceSpoergsmaal.length;
        return this.props.delopgave.multipleChoiceSpoergsmaal.map((k) => {
            i++;
            return <KonkurrenceDelopgaveSpoergsmaal key={k.id} spoergsmaal={k} index={i} numberOfQuestions={numOfQuestions} />;
        });
    }

    getHeaderButton() {
        if (this.props.konkurrenceId.length === 0) {
            return;
        }

        if (!this.props.readonly && maaBedoemme(this.props.konkurrenceDag, this.props.delopgave.opgavenBedoemmesAf)) {
            return <LinkSecondaryButton url={'/opgave-bedoemmelse/' + this.props.konkurrenceId + '/' + this.props.opgaveId + '/' + this.props.delopgave.id} text='Indtast resultat' />;
        }

        return;
    }

    render() {
        return (
            <SectionGroup header={this.getTitle()} buttons={this.getHeaderButton()}>
                {this.getDelopgaveSectionWithSpoergsmaal()}
            </SectionGroup>
        );
    }
}

export default KonkurrenceOpgaveDelopgave;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceOpgaveDelopgave.tsx